import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { Feature } from "../../interfaces/feature";
import { Epic } from "../../interfaces/epic";
import { Sprint } from "../../interfaces/sprint";

@Component({
  selector: "app-feature-canvas-item",
  templateUrl: "./feature-canvas-item.component.html",
  styleUrls: ["./feature-canvas-item.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureCanvasItemComponent {
  @Input() feature: Feature;
  @Input() sprints: Sprint[];
  @Input() featureName: string;
  @Input() featureEffort: number;
  @Input() featureEpicId: number;
  @Input() epics: Array<Epic>;
  @Input() isBeingEstimated: boolean;
  @Input() allowDelete: boolean;

  @Output() itemClicked: EventEmitter<Feature> = new EventEmitter<Feature>();
  @Output() deleteClicked: EventEmitter<Feature> = new EventEmitter<Feature>();
  @Output() moveClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() epicChanged: EventEmitter<Feature> = new EventEmitter<Feature>();

  constructor() {}

  itemCardClicked() {
    this.itemClicked.emit(this.feature);
  }

  itemDeleteClicked() {
    this.deleteClicked.emit(this.feature);
  }

  itemMoveClicked(sprint: Sprint) {
    this.moveClicked.emit({ feature: this.feature, sprint: sprint });
  }

  itemEpicChanged(feature: Feature) {
    this.epicChanged.emit(feature);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/feature-canvas-item/feature-canvas-item.component.ts